import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import EqualizerOutlinedIcon from '@material-ui/icons/EqualizerOutlined';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import List from '@material-ui/core/List';
import {withRouter} from "react-router";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import {AccountCircle} from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import {logoutUser} from "../../../services/auth.service";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import {useAuth} from "../../../context/auth";
import {useLocation} from 'react-router-dom';
import {Menu} from "@mui/material";


const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
    },
}));


const MainList = (props) => {
    const {history, path, logoutAction, isDrawerOpen} = props;
    const location = useLocation();
    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(false);
    const {setAuthToken, setAuthUser, authUser} = useAuth();
    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUserMenu(false);
        }
    }

    const handleChangePassword = (event) => {
        handleUserMenuClose(event);
        if (authUser.is_guest) {
            history.push('/auth/persist_guest_account');
        } else {
            history.push('/password/change');
        }

    }

    const ChangePasswordText = () => {
        if (authUser.is_guest) {
            return 'Sign Up'
        } else {
            return 'Change Password'
        }
    }


    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
            <List style={{flexGrow: 1}}>
                <ListItem selected={location.pathname === '/home'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/home')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <HomeOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Home"/>}
                </ListItem>

                <ListItem selected={location.pathname === '/frameworks/list'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/frameworks/list')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <BusinessOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Frameworks"/>}
                </ListItem>

                <ListItem selected={location.pathname === '/rating/programs/list'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/rating/programs/list')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <StarBorderOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Reports"/>}
                </ListItem>
                <ListItem style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          selected={location.pathname === '/programs/list'} button
                          onClick={() => history.push('/programs/list')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <InsertDriveFileOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Programs"/>}
                </ListItem>

                {/*<ListItem selected={location.pathname === '/programs/list'} button onClick={()=>history.push('/programs/list')}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <ListOutlinedIcon style={{color: '#F4F4F4'}}/>*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="Programs List"/>*/}
                {/*</ListItem>*/}


                <ListItem selected={location.pathname === '/rating/programs/assessment/list'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/rating/programs/assessment/list')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <EqualizerOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Assessments"/>}
                </ListItem>

                {/*<ListItem selected={path === 'company__view'} button onClick={()=>{toastWarning('`Not Implemented !!`');}}>*/}
                {/*    <ListItemIcon>*/}
                {/*        <PersonOutlineOutlinedIcon style={{color: '#F4F4F4'}}/>*/}
                {/*    </ListItemIcon>*/}
                {/*    <ListItemText primary="AI-Chat Bot" />*/}
                {/*</ListItem>*/}

                <ListItem selected={location.pathname === '/contact-us'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/contact-us')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <InfoRoundedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Contact Us"/>}
                </ListItem>

                <ListItem selected={location.pathname === '/account/information'}
                          style={{padding: '0px !important', justifyContent: isDrawerOpen ? 'flex-start' : 'center'}}
                          button onClick={() => history.push('/account/information')}>
                    <ListItemIcon style={{display: 'block', minWidth: 'unset',}}>
                        <SettingsOutlinedIcon style={{color: '#F4F4F4'}}/>
                    </ListItemIcon>
                    {isDrawerOpen && <ListItemText style={{marginLeft: '22px'}} primary="Account Information"/>}
                </ListItem>

            </List>
            <ListItem
                button
                onClick={handleUserMenuToggle}
                style={{
                    marginTop: 'auto',
                    padding: '0px !important',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    justifyContent: 'center'
                }}
            >
                <ListItemIcon style={{padding: '0px', display: 'block', minWidth: 'unset'}}>
                    <IconButton style={{padding: '0px', display: 'block',}} ref={anchorRefUserMenu}>
                        <Avatar
                            style={{color: 'white', backgroundColor: 'transparent', height: '55px', width: '55px',}}>
                            <AccountCircle style={{height: '35px', width: '35px',}}/>
                        </Avatar>
                    </IconButton>
                </ListItemIcon>
                {isDrawerOpen && <ListItemText style={{marginLeft: '5px'}} primary="Log out"/>}
            </ListItem>
            <Menu
                anchorEl={anchorRefUserMenu.current}
                open={Boolean(openUserMenu)}
                onClose={handleUserMenuClose}
                anchorOrigin={{vertical: 'top', horizontal: 'left'}}
                transformOrigin={{vertical: 'bottom', horizontal: 'left'}}
                PaperProps={{
                    sx: {border: '1px solid #052F44', backgroundColor: 'F4EEEE'}
                }}
            >
                <MenuItem style={{color: '#ED6628'}} onClick={handleChangePassword}>{ChangePasswordText()}</MenuItem>
                <Divider sx={{backgroundColor: '#052F44'}}/>
                <MenuItem style={{color: '#ED6628'}} onClick={handleLogout}>Logout</MenuItem>
            </Menu>

        </div>
    );
}

export default withRouter(MainList);